import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';

import styles from './ForgotPassword.styles';
import {  forgotPasswordAction } from '../../reducers/actions';
import ForgotPasswordForm from '../../components/forms/forgotpassword/ForgotPasswordForm';
import logo from '../../assets/logo_white.png';
import Image from '../../components/common/image/Image';


export class ForgotPassword extends Component {
  state = {
    showCreateAccount: false
  };
  onSubmit = values => {
    this.props.forgotPasswordAction(values.email);
  };
  render() {
    let obj = (<ForgotPasswordForm onSubmit={this.onSubmit} />) 
    if(this.props.forgotPasswordCompleted){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('forgotPassword.success')}</p>
      <Link to="/login" className={css(styles.link)}>
          {I18n.t('forgotPassword.login')}      
        </Link>
      </div>
      </div>)
    }
    return (
      <div className={css(styles.base)}>
      {obj}
      </div>
    );
  }
}

const mapStateToProps = ({ auth}) => {
  let forgotPasswordCompleted = auth.forgotPasswordCompleted
  return { forgotPasswordCompleted };
};

const mapDispatchToProps = dispatch => {
  return {
    forgotPasswordAction() {
      dispatch(forgotPasswordAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/forgotpassword/ForgotPassword.js